import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import UIkit from "uikit";
import PendingPaymentsTable from "./components/PendingPaymentsTable";
import PaidPaymentsTable from "./components/PaidPaymentsTable";
import VetoPaymentsTable from "./components/VetoPaymentsTable";
import SummaryTable from "./components/SummaryTable";
import PaymentStats from "./components/PaymentStats";

const CommunityWalletsTable = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const tab = document.getElementById("tab");
    if (tab) {
      UIkit.tab(tab, { active: 0 });
    }
    axios
      .get("/cws_infos.json")
      .then((response) => setData(response.data))
      .catch((error) => {
        console.error("Error loading the JSON file:", error);
      });
  }, []);

  return (
    <div className="container mx-auto py-4">
      <Helmet>
        <title>Community Wallets Stats - Libra World from 0L Network</title>
        <meta
          name="description"
          content="Explore Community Wallets stats on the 0L Network. Analyze the number of payees, payments, and balance of each wallet."
        />
        <link
          rel="canonical"
          href={`https://libra-world.vercel.app/community-wallets`}
        />
      </Helmet>
      <div className="w-full my-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Community Wallets Stats
        </h1>
        <h2 className="text-xl text-gray-600 max-w-lg mx-auto mb-8">
          Explore community wallets stats on the 0L Network.
        </h2>
        <PaymentStats data={data} />
        <div className="uk-margin-medium-top">
          <ul
            id="tab"
            className="uk-flex-center"
            data-uk-tab="{connect:'#tables'}"
          >
            <li>
              <a href="#summary">Summary</a>
            </li>
            <li>
              <a href="#pending-payments">Pending</a>
            </li>
            <li>
              <a href="#paid-payments">Paid</a>
            </li>
            <li>
              <a href="#veto-payments">Veto</a>
            </li>
          </ul>
          <ul id="tables" className="uk-switcher uk-margin">
            <li id="summary">
              <SummaryTable data={data} />
            </li>
            <li id="pending-payments">
              <PendingPaymentsTable jsonData={data} />
            </li>
            <li id="paid-payments">
              <PaidPaymentsTable jsonData={data} />
            </li>
            <li id="veto-payments">
              <VetoPaymentsTable jsonData={data} />
            </li>
          </ul>
        </div>
        <p className="text-gray-600 text-right my-4">
          Last Update: <span className="font-bold">{data?.created_at}</span>
        </p>
      </div>
    </div>
  );
};

export default CommunityWalletsTable;
